import type { TrackEventType, TrackCoreParams } from './types'

export const APP_ID = 'onewarehouse'

/** 聚数平台申请的项目act */
export const ACT = 'weboneshipperformance'

/**
 * 埋点事件配置
 * @see https://jdp.eclytics.com/et/event (代码埋点 Tab)
 */
export const EVENT_ID_NAME_LIST: Record<TrackEventType, TrackCoreParams> = {
  /** 地址拆分算法使用记录 */
  addressSplitAlgorithm: {
    event_id: '6108',
    event_name: 'addressSplitAlgorithm',
  },
  /** 地址拆分算法创单记录 */
  addressSplitAlgorithmOrderCreate: {
    event_id: '6107',
    event_name: 'addressSplitAlgorithm',
  },
  /** 提交预合单 */
  mergeOrderSumit: {
    event_id: '7144',
    event_name: 'mergeOrderSumit',
  },
  /** 预合单任务处理结果 */
  mergeOrderSumitResult: {
    event_id: '7145',
    event_name: 'mergeOrderSumitResult',
  },
}
